//H/t https://stackoverflow.com/a/9035732

export default function RandomPuzzle() {
    const start = new Date(1993, 10, 21);
    const rand = new Date(start.getTime() + (Math.random() * (new Date().getTime() - start.getTime())));
    window.location = `https://www.nytimes.com/crosswords/game/daily/${rand.getFullYear()}/${rand.getMonth() + 1}/${rand.getDate()}`;
    return (
        <></>
    );
};